
<style lang="scss" scope>
.ivu-mt,
.ivu-mt-16 {
  margin-top: 16px !important;
}

.items-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.flex {
  display: flex !important;
  width: 100%;
}

.flex-warp {
  flex-wrap: wrap;
}

.mr1 {
  margin-right: 1rem;
  word-wrap: +break-word;
  word-break: +norm;
}

.flexs {
  display: flex !important;
  width: 15%;
}
</style>

<template>
  <el-card shadow="never" class="l-main-card">
    <div class="l-table-toolbar">
      <div class="flex flex-warp">

        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">部门名称：</p>
          <el-input placeholder="请输入部门名" v-model="search_data.admin_name" class="input-with-select" style="width: 76%;">
            <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </el-input>
        </div>
        <!-- <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属APP：</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.app_type" placeholder="全部" clearable @change="changes" style="width: 100%;">
              <el-option v-for="item in app_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div> -->
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属公司：</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.corp_id" placeholder="全部" clearable @change="changes" style="width: 100%;">
              <el-option v-for="item in corp_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属部门：</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.depart_id" placeholder="全部" clearable @change="changes">
              <el-option v-for="item in depart_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
					<p class="mr1">用户标签：</p>
					<div class="l-show-more-search">
						<el-select v-model="search_data.is_main" placeholder="全部" clearable @change="changes">
							<el-option v-for="item in is_main" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</div>
				</div>

        <!-- <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属小组：</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.group_id" placeholder="全部" clearable @change="changes">
              <el-option v-for="item in group_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div> -->
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">日期：</p>
          <div class="l-show-more-search">
            <el-date-picker v-model="value2"  style="width: 100%;" type="datetimerange" @blur="onPick(false)"
              start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
              @change="onPick(false)"></el-date-picker>
          </div>
        </div>

        <div class="flexs items-center ivu-mt ivu-mr">
          <div class="l-show-more-search" style="width: 100%;">
            <el-button type="default" icon="el-icon-refresh" @click="clearSearch">重置</el-button>
          </div>
        </div>

        <div class="flexs items-center ivu-mt ivu-mr">
          <el-tag class="marginRB10">充值金额 ¥： <span>{{ this.recharge_total }} 元 </span></el-tag>
          <el-tag class="marginRB10" style="margin-left: 5px;">转账金额 ¥： <span>{{ this.transfer_total }} 元 </span></el-tag>
          <el-tag class="marginRB10" style="margin-left: 5px;">总金额 ¥： <span>{{ this.total }} 元 </span></el-tag>
          <el-tag class="marginRB10" style="margin-left: 5px;">总有效注册数 ： <span>{{ this.void }} 人 </span></el-tag>
          <el-tag class="marginRB10" style="margin-left: 5px;">总充值人数 ： <span>{{ this.void_recharge }} 人 </span></el-tag>
        </div>
      </div>
    </div>
    <l-table :data="data" v-loading="loading" row-key="id">
      <el-table-column fixed prop="index" label="序号" width="80"> </el-table-column>
      <el-table-column prop="name" label="部门" min-width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="corp_name" label="公司" min-width="200" show-overflow-tooltip></el-table-column>
      <el-table-column prop="void_user_total" label="有效注册数" min-width="160" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="invalid_user_total" label="无效注册数" min-width="160" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="day_recharge_user_total" label="充值人数" min-width="160" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="recharge_total" label="充值金额" min-width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="guild_recharge_total" label="转账金额" min-width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="total" label="总金额" min-width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="user_pay_total" label="用户总流水" min-width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="day_recharge_user_total" label="优质用户" min-width="160" show-overflow-tooltip>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="130" align="center">
        <template slot-scope="{ row }">
          <l-auth-text-button type="primary" auth="d_info_btn" @click="showInfo(row.id)"><i
              class="el-icon-warning-outline"></i>详情</l-auth-text-button>
        </template>
      </el-table-column>
    </l-table>

    <!--分页-->
    <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size"
      :current-page.sync="page"></l-page>

    <!--详情-->
    <l-dialog :visible.sync="info_visible" title="详情" width="76%">
      <l-user-achievemet-depart :visible.sync="info_visible" :valueData="value2" :is_main="search_data.is_main" :id="info_id" />
    </l-dialog>

  </el-card>
</template>

<script>
import Vue from "vue";
import Info from "./Info.vue";
export default {
  name: "l-AchievementGroup",
  components: {
    [Info.name]: Info,
  },
  data() {
    return {
      info_id:0,
      info_visible:false,
      box: 1,
      is_main: [
				{ "id": 1, "name": "小号" },
				{ "id": 2, "name": "大号" }
			],
      data: [],
      count: 0,
      page: 1,
      page_size: Vue.$_config.page.page_size,
      loading: false,
      //搜索
      total: 0,
      recharge_total: 0,
      transfer_total: 0,
      total_amount: 0,
      void:0,
      void_recharge:0,
      search_visible: false,
      search_data: {
        admin_name: "",
        app_type: "",
        start_time: "",
        end_time: "",
        corp_id: "",
        depart_id: "",
        group_id: "",
        is_main:"",
        renovate_code:0
      },
      rel_search_data: {},
      show_more_search: false,
      value2: "",
      value2_check: "",
      corp_list: [],
      depart_list: [],
      group_list: [],
      app_list: []
    };
  },

  mounted() {
    this.getInitializeDate();
    this.getList();
    this.getSearchData();

  },

  methods: {
    getInitializeDate() {
			let date = new Date()
			let year = date.getFullYear().toString()
			//获取当前月份，因为月份是要从0开始，此处要加1，
			let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()
			let start = year + '-' + month + '-01 00:00:00'
			let day = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString()
			let end = year + '-' + month + '-' + day + ' 23:59:59'
			this.value2 = [start,end]
		},
    getSearchData() {
      // this.loading = true;
      this.$_invoke("adminUser_getSearchData", {
        corp_id: this.search_data.corp_id,
        depart_id: this.search_data.depart_id,
        group_id: this.search_data.group_id,
      })
        .then((ret) => {
          this.corp_list = ret.corp_list;
          this.depart_list = ret.depart_list;
          this.group_list = ret.group_list;
          this.app_list = ret.app_list;
        })
        .finally(() => {
          // this.loading = false;
        });

    },
    // 点击 更改部门
    changes() {
      this.getList();
      this.getSearchData();
    },
    onPick(cant) {
      if (!this.value2) {
        this.value2 = "";
        this.search_data.start_time = "";
        this.search_data.end_time = "";
      } else {
        this.search_data.start_time = this.value2[0];
        this.search_data.end_time = this.value2[1];
      }
      if (!cant) {
        this.onSearch();
      }
    },

    // onPick_check(cant) {
    //   if (!this.value2_check) {
    //     this.value2_check = "";
    //     this.search_data.check_start_time = "";
    //     this.search_data.check_end_time = "";
    //   } else {
    //     this.search_data.check_start_time = this.value2_check[0];
    //     this.search_data.check_end_time = this.value2_check[1];
    //   }
    //   if (!cant) {
    //     this.onSearch();
    //   }
    // },
    //获取数据
    getList() {
      this.loading = true;
      this.$_invoke("achievementDepart_getList", {
        page: this.page,
        page_size: this.page_size,
        ...this.search_data,
      })
        .then((ret) => {
          // console.log(ret.data);
          this.data = ret.data;
          this.count = ret.count;
          this.total = ret.total;
          this.recharge_total = ret.recharge_total;
          this.transfer_total = ret.transfer_total;
          this.void = ret.void;
          this.void_recharge = ret.void_recharge;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    //显示详情
    showInfo(id) {
      this.info_id = id;
      this.$nextTick(() => {
        this.info_visible = true;
      });
    },

    //清除搜索数据
    clearSearch() {
      this.search_data.admin_name = "";
      this.search_data.app_type = "";
      this.search_data.corp_id = "";
      this.search_data.depart_id = "";
      this.search_data.group_id = "";
      this.search_data.end_time = "";
      this.search_data.start_time = "";
      this.search_data.start_time = "";
      this.search_data.renovate_code = 200 ;
      this.corp_list = [];
      this.depart_list = [];
      this.group_list = [];
      this.app_list = [];
      this.getList();
      this.getSearchData();
    },
  },
};
</script>
